module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_3_6_3.a3a997ad.jpeg";